import { createFileRoute } from "@tanstack/react-router";
import { RoomManager } from "@/features/admin/RoomManager";
import { BookingsList } from "@/features/admin/BookingsList";

export const Route = createFileRoute("/admin")({
  component: AdminPanel,
});

function AdminPanel() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-8">
      <h1 className="mb-8 text-2xl font-bold">Admin Panel</h1>

      <div className="grid gap-8 lg:grid-cols-2">
        <div className="rounded-lg border border-border bg-card p-6">
          <RoomManager />
        </div>
        <div className="rounded-lg border border-border bg-card p-6">
          <BookingsList />
        </div>
      </div>
    </div>
  );
}
